<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Megtekintés"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-view"
        @click="viewRepresentativeTransfer"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      content="Export"
      placement="top"
    >
      <el-button
        size="mini"
        :loading="exportButtonLoader"
        icon="el-icon-download"
        @click="exportRepresentativeTransfer"
      />
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['representativeTransfer'],
    data() {
      return {
        exportButtonLoader: false,
      };
    },

    methods: {
      viewRepresentativeTransfer() {
        this.$router.push('/representative-processes/representative-transfers/view/' + this.representativeTransfer.id);
      },
      async exportRepresentativeTransfer() {
        try {
          this.exportButtonLoader = true;
          const excel = await axios({
            url: 'api/representative-transfers/' + this.representativeTransfer.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'RepresentativeTransferItemExport.xlsx');
        } catch (e) {
        }
        this.exportButtonLoader = false;
      },
    }
  };
</script>
